import request from '@/utils/request'

const root = (meetingCode) => `/user/admin/meeting/transcript/${encodeURIComponent(meetingCode)}`
export const getTranscriptSessions = (meetingCode) => request({ url: `${root(meetingCode)}/sessions`, method: 'get' })
export const getTranscriptSentences = (meetingCode, params) =>
  request({ url: `${root(meetingCode)}/sentences`, method: 'get', params })
export const getTranscriptPlayback = (meetingCode, captureSessionId) =>
  request({ url: `${root(meetingCode)}/playback-url`, method: 'post', params: { captureSessionId } })

export const prepareTranscriptAudio = (meetingCode, captureSessionId) =>
  request({ url: `${root(meetingCode)}/prepare-audio`, method: 'post', params: { captureSessionId } })
